import { ButtonBase, Link, Stack, Typography, Box, Button, IconButton } from '@mui/material';
import React, { useRef } from 'react';
import { AppColors } from '../Utils/helper/AppColors';
import { CloseIcon, UploadIcon } from './Icons/Icons';

export default function DragDropUpload(props) {
	const { borderColor, subText, sampleFile, onUpload, extra, noBorderIcon, isModel, onClose, dragDrop = true } = props;

	const fileRef = useRef();

	const downloadSample = (e) => {
		e.stopPropagation();

		const link = document.createElement('a');
		link.href = `/sample/${sampleFile}`;
		link.download = sampleFile;
		link.click();
	};

	const handleDragOver = (e) => {
		e.preventDefault();
	};

	const handleDrop = (e) => {
		e.preventDefault();
		console.log('Dropped files inside the component');
		const droppedFiles = Array.from(e.dataTransfer.files);
		onUpload({ target: { files: droppedFiles } });
	};


	return (
		<div
			onDrop={dragDrop ? handleDrop : undefined}
			onDragOver={dragDrop ? handleDragOver : undefined}
			onClick={() => fileRef.current.click()}
			// style={{
			//     border: '2px dashed #999',
			//     padding: 40,
			//     textAlign: 'center',
			//     cursor: 'pointer',
			// }}
		>
			<Box
				sx={{
					borderRadius: '12px',
					border: noBorderIcon ? 'none' : `1px solid ${borderColor || AppColors.BORDER_GREY}`,
					cursor: 'default',
				}}
			>
				<input
					type="file"
					ref={fileRef}
					hidden
					onChange={(e) => {
						onUpload(e);
						e.target.value = '';
					}}
				/>

				<Stack alignItems="center" justifyContent="center" width="100%" py={2} px={4} gap={0.5}>
					{!noBorderIcon && (
						<Stack
							alignItems="center"
							justifyContent="center"
							height={40}
							width={40}
							borderRadius={2}
							border="1px solid"
							borderColor={AppColors.BORDER_GREY}
						>
							<UploadIcon color={AppColors.TEXT_SECONDARY} size={20} />
						</Stack>
					)}

					<Typography sx={{ fontSize: 14, fontFamily: 'Poppins', fontWeight: 400, lineHeight: '150%', color: AppColors.BLACK }}>
						{isModel ? (
							<>Click to upload or drag and drop</>
						) : (
							<>
								<span
									onClick={(e) => { e.stopPropagation();  fileRef.current.click()}}
									style={{ color: AppColors.PRIMARY_DARK, fontWeight: 600, cursor: 'pointer' }}
								>
									Click to upload
								</span>{' '}
								or drag and drop
							</>
						)}
					</Typography>

					<Stack direction="row" alignItems="center" gap={1}>
						<Typography sx={{ fontSize: 14, fontFamily: 'Poppins', fontWeight: 400, lineHeight: '150%', color: AppColors.BLACK }}>
							{subText}
						</Typography>
						{sampleFile && (
							<Link color={AppColors.PRIMARY_DARK} fontSize={13} onClick={downloadSample}>
								Download Sample file
							</Link>
						)}
					</Stack>

					{extra && (
						<Typography
							textAlign={'center'}
							sx={{ fontSize: 14, fontFamily: 'Poppins', fontWeight: 400, lineHeight: '150%', color: AppColors.BLACK, px: 14 }}
						>
							{extra}
						</Typography>
					)}

					{isModel && (
						<Button
							variant="contained"
							onClick={(e) => {
								e.stopPropagation(); // Prevents the outer div's onClick from firing
								fileRef.current.click();
							}}
							sx={theme => ({
								mt: 2,
								color: AppColors.WHITE,
								fontWeight: 600,
								background: theme.palette.primary.primary_shade,
								boxShadow: 'none',
								borderRadius: '4px',
								// '&:hover': { background: '#E5E0FF' },
							})}
						>
							Upload File
						</Button>
					)}
				</Stack>
			</Box>
		</div>
	);
}
